<template>
    <form method="GET" :action="searchEndpointUri" ref="searchForm">
        <div class="d-flex flex-wrap flex-sm-nowrap">
            <select v-if="fields" name="field" class="form-control w-30 mr-2 px-2" style="min-width: 115px;" @change="submitForm">
                <option v-for="(field, index) in fields"
                        :key="index"
                        :value="field.value"
                        :selected="field.selected">
                    {{ translate('frontend.search.form.search_fields.' + field.label) }}
                </option>
            </select>

            <input type="search" id="query" name="q" class="form-control mr-2" v-model="query" :placeholder="placeholder">

            <slot name="search-button">
                <button type="submit" id="submit-query" class="btn btn-primary mr-2">
                    {{ translate('frontend.search.form.search_button') }}
                </button>
            </slot>

            <slot name="reset-button">
                <button @click.prevent="onReset" class="btn btn-light btn-reset">
                    {{ translate('frontend.search.form.reset_button') }}
                </button>
            </slot>

            <slot name="help">
                <a href="#" data-toggle="modal" data-target="#helpModal" class="help d-flex ml-3 align-items-center">
                    <i class="fa fa-question-circle lead"></i>
                </a>
                <modal modalId="helpModal"
                    :modalTitle="translate('frontend.search.help_modal.title')"
                    :modalBody="translate('frontend.search.help_modal.body')"
                    :secondaryButton="translate('frontend.search.help_modal.secondary_button')"
                    modal-size="lg">
                </modal>
            </slot>
        </div>
    </form>
</template>

<script>
    export default {
        props: {
            searchEndpointUri: { type: String, required: true },
            searchQuery: { type: String, required: true },
            searchFields: { type: Object, required: false, default: null },
            placeholder: { type: String, default: '' }
        },

        data() {
            return {
                query: this.searchQuery,
                fields: this.searchFields
            }
        },

        methods: {
            onReset() {
                // reset the search query
                this.query = '';

                // reset the search field
                for (let field in this.fields) {
                    this.fields[field].selected = false;
                }
                this.fields['all'].selected = true;

                // auto-submit the form when the clear button is pressed
                this.$nextTick(() => {
                    this.submitForm();
                });
            },

            submitForm() {
                this.$refs.searchForm.submit();
            }
        }
    }
</script>

<style lang="scss" scoped>
    a.help {
        color: #999;
        &:hover {
            color: #4e725b;
        }
        i {
            font-size: 1.25rem;
        }
    }

    select {
        height: 36px;
    }

    #query {
        font-size: 1rem !important;
        line-height: 1.6;
        padding: 0.75rem 1rem;
        height: 36px;
    }

    button {
        height: 36px;
        min-width: 110px;
        font-size: 1.1rem;
    }
</style>
